<template>
  <span class="box">
    <span
      v-if="!hideLabel"
      class="country-label"
      :style="{order: beforeImg ? '2' : '0'}"
    >
      {{this.$utils.pipeCountryCode(code)}}
    </span>
    <img
      class="country-img"
      :src="imgUrl"
    />
  </span>
</template>

<script>
const imagesContext = require.context('../../../static/images/Country/', false, /\.(png|jpg|gif|jpeg|webp|ico)$/)
const chunks = imagesContext.keys().reduce((chunks, key) => {
  const simpleKey = key.split('/').pop().split('.')[0]
  return Object.assign(chunks, { [simpleKey]: imagesContext(key) })
}, {})

export default {
  props: {
    code: { // 国家编码
      type: [Number, String],
      default: ''
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    beforeImg: { // 图片在前
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    }
  },
  computed: {
    imgUrl() {
      return chunks[this.code]
    },
  },
}
</script>

<style lang="scss" scoped>
.box{
  display: flex;
  align-items: center;
  .country-label{
    line-height: 1em;
    margin-right: 4px;
  }
  .country-img{
    width: 17px;
    order: 1;
  }
}
</style>
